
  import { defineComponent, PropType } from 'vue';

  import { TStorePaths } from '@/common/types/storePaths';

  import {
    ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME,
    ANALYTICS_NOTES_MONTHLY_GETTERS_NAME,
    ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME,
  } from '../../store/analyticsNotesMonthly/name';
  import {
    ANALYTICS_NOTES_YEARLY_ACTIONS_NAME,
    ANALYTICS_NOTES_YEARLY_GETTERS_NAME,
    ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME,
  } from '../../store/analyticsNotesYearly/name';
  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import AnalyticsNotesProductsTable from './AnalyticsNotesProductsTable.vue';

  export default defineComponent({
    name: 'AnalyticsNotesProductsImportTable',
    components: {
      AnalyticsNotesProductsTable,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getStorePaths(): TStorePaths {
        return this.isMonthly
          ? {
              action: ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchImportProductsTable,
              getter: ANALYTICS_NOTES_MONTHLY_GETTERS_NAME.getImportProductsTable,
              mutation: ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME.setImportProductsTable,
            }
          : {
              action: ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchImportProductsTable,
              getter: ANALYTICS_NOTES_YEARLY_GETTERS_NAME.getImportProductsTable,
              mutation: ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME.setImportProductsTable,
            };
      },
    },
  });
